export const CUSTOMER_SEGMENT = {
  PERSONAL: "Personal",
  BUSINESS: "Business",
} as const;

// Type definition for customer segment values
export type CustomerSegment = (typeof CUSTOMER_SEGMENT)[keyof typeof CUSTOMER_SEGMENT];
